// extracted by mini-css-extract-plugin
export var equalColumn = "_j0-0";